// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#007298","successColor":"#5cb85c","infoColor":"#5bc0de","warningColor":"#f0ad4e","dangerColor":"#d9534f"};